import React from "react";

const sizes = {
  texts: "text-[24px] font-medium lg:text-[20px] md:text-[22px]",
  textmd: "text-[55px] font-medium lg:text-[46px] md:text-[47px] sm:text-[41px]",
  text4xl: "text-[34px] font-medium lg:text-[28px] md:text-[32px] sm:text-[30px]",
  text5xl: "text-[39px] font-medium lg:text-[33px] md:text-[37px] sm:text-[35px]",
  text6xl: "text-[42px] font-medium lg:text-[35px] md:text-[38px] sm:text-[32px]",
  headingxs: "text-[28px] font-bold lg:text-[23px] md:text-[26px] sm:text-[24px]",
};

export type HeadingProps = Partial<{
  className: string;
  as: any;
  size: keyof typeof sizes;
}> &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;

const Heading: React.FC<React.PropsWithChildren<HeadingProps>> = ({
  children,
  className = "",
  size = "text4xl",
  as,
  ...restProps
}) => {
  const Component = as || "h6";

  return (
    <Component className={`text-red-a200 font-oswald ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Heading };
